/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Add_Box_MasterInputs */



/**
* | output |
* | --- |
* | "Box Master" |
*
* @param {Gateway_Add_Box_MasterInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const gateway_add_box_master = /** @type {((inputs?: Gateway_Add_Box_MasterInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Add_Box_MasterInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Box Master")
	return /** @type {LocalizedString} */ ("Box Master")
});